export default "__VITE_ASSET__q4yHz7i6__"